import { useTranslation } from 'react-i18next'

import type { HTMLChakraProps } from '@enechain/ecloud-designsystem'
import {
  RadioGroupItemControl,
  RadioGroupItemHiddenInput,
  RadioGroupItem as RawRadioGroupItem,
  RadioGroupItemText as RawRadioGroupItemText,
} from '@enechain/ecloud-designsystem'

import { ButtonTooltip } from '~/components/common/ButtonTooltip'
import { INTRADAY_P8_AVAILABLE } from '~/pages/IntradayBidding/models/intradayP8Availability'

// chakra v3 の `RadioGroupItem*Props` は d.ts 解決の問題で `children` / 固有 prop が欠落する。
// 札作成モーダルと同じく、 v3 本来の prop シグネチャへ cast して復元する (ランタイムは ecloud のまま)。
const RadioGroupItem = RawRadioGroupItem as React.FC<
  HTMLChakraProps<'div'> & { value: string; disabled?: boolean }
>
const RadioGroupItemText = RawRadioGroupItemText as React.FC<
  HTMLChakraProps<'span'>
>

/**
 * 準備中 (P8) の選択肢の名前に、 押せない理由「この機能は準備中です」 のツールチップを付ける
 * (AC-BIN-133)。 非活性の選択肢は focus を受けないので、 名前を包みでくるみ、 包みを Tab で止める。
 * P8 を使える間 (`INTRADAY_P8_AVAILABLE`) は名前をそのまま出す。
 */
export const IntradayPreparingOptionLabel = ({
  children,
}: {
  children: React.ReactNode
}): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <ButtonTooltip
      content={
        INTRADAY_P8_AVAILABLE
          ? undefined
          : t('page:biddingIntraday.form.featurePreparing')
      }
      focusable
    >
      {children}
    </ButtonTooltip>
  )
}

/**
 * ラジオの準備中の選択肢 (AC-BIN-133)。 `RadioGroupRoot` の中に置く。
 * P8 を使える間 (`INTRADAY_P8_AVAILABLE`) は、 押せる普通の選択肢にする。
 */
export const IntradayPreparingRadioItem = ({
  value,
  label,
}: {
  value: string
  label: string
}): React.ReactElement => (
  <RadioGroupItem disabled={!INTRADAY_P8_AVAILABLE} value={value}>
    <RadioGroupItemHiddenInput />
    <RadioGroupItemControl />
    <RadioGroupItemText
      color={INTRADAY_P8_AVAILABLE ? undefined : 'Text.disabled'}
    >
      <IntradayPreparingOptionLabel>{label}</IntradayPreparingOptionLabel>
    </RadioGroupItemText>
  </RadioGroupItem>
)
